"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimisedArrayAdd = exports.ArrayUtils = void 0;
var lodash_1 = require("lodash");
var advanced_logic_error_1 = require("../util/advanced-logic-error");
exports.ArrayUtils = {
    isArray: function (arr) {
        return lodash_1.isArray(arr);
    },
    isEmpty: function (arr) {
        return !this.isArray(arr) || arr.length === 0;
    },
    contains: function (arr, arg) {
        if (!this.isArray(arr)) {
            return false;
        }
        else {
            var found = arr.find(function (el) {
                return lodash_1.isEqual(el, arg);
            });
            return found !== undefined;
        }
    },
    some: function (arr, func) {
        if (!this.isArray(arr)) {
            return false;
        }
        else {
            var found = arr.find(func);
            return found !== undefined;
        }
    },
    every: function (arr, func) {
        return this.isArray(arr) && arr.every(func);
    },
    swapBy: function (arr, newElement, key, value) {
        var index = lodash_1.findIndex(arr, function (el) {
            return el[key] === value;
        });
        if (index === -1) {
            throw new advanced_logic_error_1.AdvancedLogicError("key: " + key + " with value: " + value + " was not found in the given array.");
        }
        var result = __spreadArrays(arr);
        result[index] = newElement;
        return result;
    },
    removeBy: function (arr, key, value) {
        var index = lodash_1.findIndex(arr, function (el) {
            return el[key] === value;
        });
        if (index === -1) {
            throw new advanced_logic_error_1.AdvancedLogicError("key: " + key + " with value: " + value + " was not found in the given array.");
        }
        var result = __spreadArrays(arr);
        result.splice(index, 1);
        return result;
    },
};
function optimisedArrayAdd(array, node) {
    // faster, inline, shallow array clone implementation
    var arrayLength = array.length;
    var newArray = Array(arrayLength + 1);
    for (var i = 0; i < arrayLength; i++) {
        newArray[i] = array[i];
    }
    newArray[arrayLength] = node;
    return newArray;
}
exports.optimisedArrayAdd = optimisedArrayAdd;
